import { svg } from "config/svgStyles";

export const modalContainer = () => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 3000,
  background: "rgba(0,0,0,0.5)",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  px: "20px",
  py: "40px",
});

export const centeredBox = ({ UIVersion, maxWidthOverride }) => ({
  position: "relative",
  zIndex: 2000,
  background: "background",
  overflow: "hidden",
  // display: "flex",
  // flexDirection: "column",
  // alignItems: "center",
  borderRadius: "10px",
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.375)",
  maxWidth: maxWidthOverride
    ? maxWidthOverride
    : UIVersion === 2
    ? "400px"
    : "640px",
  width: "100%",
  // padding: "40px",
});

export const closeButton = () => ({
  backgroundColor: "black",
  height: "40px",
  width: "40px",
  borderRadius: "0 10px",
  margin: "0",
  padding: "0",
  position: "absolute",
  top: "0",
  right: "0",
  zIndex: 100,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    width: "14px",
    ...svg("white"),
  },

  "&:hover": {
    backgroundColor: "primary",
    svg: {
      ...svg("white"),
    },
  },
  "&:focus": {
    svg: {
      ...svg("white"),
    },
  },

  transition: "background-color 0.3s, border-color 0.3s",
});
